import { Button, ButtonGroup, Flex, Input } from "@chakra-ui/react";
import { useRef, useState } from "react";
import { useIntl } from "react-intl";
import { useLocation } from "wouter";

import { useScenario } from "@nens/ldo/api-v1";

export function GoToScenarioButton() {
  const toScenarioInputRef = useRef<HTMLInputElement>(null);
  const [currentScenarioId, setCurrentScenarioId] = useState(0);

  const setLocation = useLocation()[1];
  const intl = useIntl();

  const changeInput = () => {
    const scenarioId = parseInt(toScenarioInputRef?.current?.value || "0");
    if (!isNaN(scenarioId)) {
      setCurrentScenarioId(scenarioId);
    }
  };

  const goToScenario = () => {
    if (scenarioResponse.isSuccess) {
      setLocation(`/scenarios/${currentScenarioId}`);
    }
  };

  const scenarioResponse = useScenario(currentScenarioId);

  return (
    <Flex alignItems="center">
      <ButtonGroup isAttached variant="outline">
        <Input
          ref={toScenarioInputRef}
          w="8rem"
          size="sm"
          colorScheme="whiteAlpha"
          bgColor="white"
          placeholder={intl.formatMessage({
            id: "toscenario.placeholder",
            defaultMessage: "Scenario ID",
          })}
          onChange={changeInput}
          onKeyUp={(e) => e.key === "Enter" && goToScenario()}
        />
        <Button h={8} onClick={goToScenario} isDisabled={!scenarioResponse.isSuccess}>
          {intl.formatMessage({
            id: "toscenario.go",
            defaultMessage: "Go",
          })}
        </Button>
      </ButtonGroup>
    </Flex>
  );
}
